(function($, Cobalt, undefined) {
    Cobalt.DayTimeSelector = {
        startEndSelectors: ['start', 'end'],

        initialize: function() {
            $('.day-time-selector.editable .day').click(function(event, fromCode) {
                var $element = $(this).parents('.day-of-week');

                var childElements = $element.find('.time-value, .time-start, .time-end');
                if ($element.hasClass('active')) {
                    childElements.css('visibility', 'hidden');
                    $element.removeClass('active');
                } else {
                    childElements.css('visibility', 'visible');
                    $element.addClass('active');
                }

                if (!fromCode) {
                    var $selector = $element.parents('.day-time-selector');
                    $selector.trigger('change');

                    Cobalt.DayTimeSelector.updateInputFieldsFromForm($selector);
                }
            });

            // initialization of selectors...
            $('.day-time-selector.editable').each(function() {
                var $selector = $(this);

                var $form = $(this).parents('.day-time-selector-field');
                if ($form.length == 1) {
                    $selector.data('form', $form);
                }

                // set default timezone
                var offset = (new Date().getTimezoneOffset()) * -1;
                var $timeZoneSelector = $selector.find('.time-zone .zones');

                $selector.find('.time-zone .go-next').click(function() {
                    $timeZoneSelector.val($timeZoneSelector.find(':selected').next().attr('value'));
                    $timeZoneSelector.change();
                    return false;
                });

                $selector.find('.time-zone .go-prev').click(function() {
                    $timeZoneSelector.val($timeZoneSelector.find(':selected').prev().attr('value'));
                    $timeZoneSelector.change();
                    return false;
                });

                $timeZoneSelector.change(function() {
                    $selector.find('.time-zone .time-zone-display').text($timeZoneSelector.find(':selected').text());
                });

                if ($timeZoneSelector.children('[value=' + offset + ']').length == 1) {
                    $timeZoneSelector.val(offset);
                } else {
                    $timeZoneSelector.val(0);
                }

                $timeZoneSelector.change();

                Cobalt.DayTimeSelector.updateFormFromInputFields($selector);
            });

            $('.day-time-selector.editable .time-add, .day-time-selector.editable .time-minus').click(function(event, fromCode) {
                var clickedElement = $(this);
                var start = clickedElement.hasClass('time-start');
                var add = clickedElement.hasClass('time-add');

                var element;
                if (add) {
                    element = clickedElement.prev();
                } else {
                    element = clickedElement.next();
                }

                var delta = add ? 30 : -30;
                var time = element.data('time');
                time += delta;

                if (time > 1410) {
                    time = 0;
                } else if (time < 0) {
                    time = 1410;
                }
                element.data('time', time);

                var otherElement = clickedElement.parents('.day-of-week').find('.time-' + (start ? 'end' : 'start') + '-value');
                var otherTime = otherElement.data('time');
                if (time == otherTime) {
                    if (add) {
                        otherElement.next().click();
                    } else {
                        otherElement.prev().click();
                    }
                }

                if (fromCode == undefined || !fromCode) {
                    var $selector = element.parents('.day-time-selector');
                    $selector.trigger('change');
                    Cobalt.DayTimeSelector.updateInputFieldsFromForm($selector);
                }

                var formattedTime = Cobalt.DayTimeSelector.getFormattedTime(time);
                element.text(formattedTime);
            });

            $('.day-time-selector.editable .time-add-all, .day-time-selector.editable .time-minus-all').click(function() {
                var element = $(this);
                var $selector = element.parents('.day-time-selector');
                var activeDayLength = $selector.find('.day-of-week.active').length;

                if (activeDayLength > 0) {
                    var add = element.hasClass('time-add-all');
                    var start = element.hasClass('time-start');
                    // only change active days
                    var selector = '.day-of-week.active .time-' + (add ? 'add' : 'minus') + '.time-' + (start ? 'start' : 'end');

                    $selector.find(selector).trigger('click', { fromCode: true });

                    Cobalt.DayTimeSelector.updateInputFieldsFromForm($selector);

                    $selector.trigger('change');
                }
            });
        },

        getFormattedTime: function(minutes) {
            var hour = Math.floor(minutes / 60);
            var minute = minutes % 60;

            return (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute);
        },

        updateInputFieldsFromForm: function($selector) {
            var $form = $selector.data('form');
            if ($form == undefined) {
                return;
            }

            var $inputFields = $form.find('.input-fields');

            $form.find('.day-of-week').each(function() {
                var $dayOfWeek = $(this);
                var day = $dayOfWeek.attr('data-day').toLowerCase();
                var start,
                    end;

                if ($dayOfWeek.hasClass('active')) {
                    start = $dayOfWeek.find('.time-start-value').data('time');
                    end = $dayOfWeek.find('.time-end-value').data('time');
                } else {
                    start = null;
                    end = null;
                }

                $inputFields.find('#field-' + day + '-start').val(start);
                $inputFields.find('#field-' + day + '-end').val(end);
            });
        },

        updateFormFromInputFields: function($selector) {
            var hasFields = false;
            var $form = $selector.data('form');
            var $inputFields;

            if ($form != undefined) {
                hasFields = true;
                $inputFields = $form.find('.input-fields');
            }

            $selector.find('.day-of-week').each(function() {
                var $dayOfWeek = $(this);

                var $start = $dayOfWeek.find('.time-start-value');
                var $end = $dayOfWeek.find('.time-end-value');
                var start = 1020,
                    end = 1380;

                if (hasFields) {
                    var day = $dayOfWeek.attr('data-day');

                    var inputStart = parseInt($inputFields.find('#field-' + day + '-start').val());
                    var inputEnd = parseInt($inputFields.find('#field-' + day + '-end').val());

                    if (!isNaN(inputStart) && !isNaN(inputEnd)) {
                        start = inputStart;
                        end = inputEnd;

                        $dayOfWeek.find('.day').trigger('click', { fromCode: true });
                    }
                }

                Cobalt.DayTimeSelector.setTimeValue($start, start);
                Cobalt.DayTimeSelector.setTimeValue($end, end);
            });
        },

        setTimeValue: function($element, time) {
            $element.text(Cobalt.DayTimeSelector.getFormattedTime(time));
            $element.data('time', time);
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.DayTimeSelector.js